import ManagmentMenu from "../management-menu/ManagmentMenu";
export default function ManagmentMenuPage() {
  return (
    <div>
      <ManagmentMenu></ManagmentMenu>
    </div>
  );
}
